const INITIAL_STATE = {
  callingMeteringService: false,
};

export const meteringServiceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CALL_METERING_SERVICE":
      return {
        ...state,
        callingMeteringService: true
      };

    case "METERING_SERVICE_CALL_ENDED":
      return {
        ...state,
        callingMeteringService: false
      };

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/Maintenance/meteringServiceReducer.js